import axios from 'axios';
let host = window.location.hostname;
//let domain = `https://mtlcargo.net`;
let domain = `https://localhost.com:8443`;
if (host.toLowerCase().includes('jaekjay')) {
	domain = `https://mtlcargo.jaekjay.com`;
}
if (host.toLowerCase().includes('mtlcargo.net')) {
	domain = `https://mtlcargo.net`;
}

const api = axios.create({
	baseURL: domain,
});
let isRefreshing = false;
let failedQueue = [];
const processQueue = (error, token = null) => {
	failedQueue.forEach((prom) => {
		if (error) {
			prom.reject(error);
		} else {
			prom.resolve(token);
		}
	});
	failedQueue = [];
};
api.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem('token');
		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`;
		}
		return config;
	},
	(error) => Promise.reject(error)
);
api.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config;

		if (error.response?.status === 401 && !originalRequest._retry) {
			if (isRefreshing) {
				return new Promise((resolve, reject) => {
					failedQueue.push({ resolve, reject });
				})
					.then((token) => {
						originalRequest.headers['Authorization'] =
							'Bearer ' + token;
						return api(originalRequest);
					})
					.catch((err) => Promise.reject(err));
			}

			originalRequest._retry = true;
			isRefreshing = true;

			try {
				const { data } = await axios.get(
					domain + '/api/user/refresh/token',
					{ withCredentials: true }
				);

				const newToken = data.token;
				localStorage.setItem('token', newToken);
				console.log(newToken);
				api.defaults.headers.common['Authorization'] =
					'Bearer ' + newToken;
				processQueue(null, newToken);

				return api(originalRequest);
			} catch (err) {
				processQueue(err, null);
				window.location.href = '/#/logout';
				return Promise.reject(err);
			} finally {
				isRefreshing = false;
			}
		}

		return Promise.reject(error);
	}
);
export default api;
